import React from 'react';
import SvgIcon from './SvgIcon';

const EventFeed = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M.75.75h22.5v22.5H.75V.75z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.75 4.5h4.5-4.5zm0 3h7.5-7.5zm0 3h7.5-7.5zm0 3h4.5-4.5zm0 3h7.5-7.5zm-9-12h6v6h-6v-6zm0 9h6v6h-6v-6z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

EventFeed.displayName = 'EventFeedIcon';

export default EventFeed;
